import { useFlyOutProductsBasedOnSelectedCloud } from '../../../common/utils/hooks/useFlyOutProductsBasedOnSelectedCloud'
import { SidePanelV3 } from '@labrav/react-components'
import { useStyles } from './AddEditProductListingMicrosoft.styles'
import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faList,
  faInputText,
  faBell,
  faCircleCheck,
  faArrowLeft,
} from '@fortawesome/pro-regular-svg-icons'
import {
  FlyoutListingProductType,
  FlyoutProductAddEditSectionName,
  PoductObjectInCreation,
} from '../../../types/addEditProduct'
import { Form, Formik } from 'formik'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { getProductInCreationMicrosoft } from '../../../modules/addEditProduct/action'
import { useDispatch, useSelector } from '../../../store/hooks'
import { isEmpty } from 'lodash'
import {
  getIsProductSectionCompletedMicrosoft,
  getPageProductCreation,
  getProductCompletePercentage,
  validateMicrosoftProductCreationFlow,
} from '../../../common/utils/productCreationUtil'
import clsx from 'clsx'
import { Typography } from '@mui/material'
import { SnackBar, TeamMembersV2 } from '@labrav/common'
import { getProducts } from '../../../modules/productsListing/action'
import { ScrollToFieldError } from '@labrav/common'
import {
  useAccountId,
  ShortenedNameV2,
  type UserProfileState,
  SelectedCloudIcon,
} from '@labrav/common'
import { SecondaryNavigationRoutesType } from '@labrav/react-components/lib/@types/v3/components/SidePanel'
import { FlyOutMigrationProductsList } from '../../AddEditProductFormComponents/Microsoft/FlyOutMigrationProductsList/FlyOutMigrationProductsList'
import { AddEditProductListingFooter } from './AddEditProductListingFooter/AddEditProductListingFooter'
import FlyoutProductValidationSchemaMicrosoft from '../../../common/utils/FlyoutProductValidationSchemaMicrosoft'
import { FlyoutNotificationSectionMicrosoft } from './FlyOutNotificationSectionMicrosoft/FlyoutNotificationSectionMicrosoft'
import { FlyoutLandingPageSection } from './FlyoutLandingPageSection/FlyoutLandingPageSection'
import { getFlyOutMigrationProductsData } from '../../../modules/addEditProduct/productsInfo/action'
import { CloudType } from '../../../types/index'
import { ProductStatus } from '../../../modules/productsListing/types'
import { useSyncFlyoutRouteParams } from '../../../common/utils/hooks/useSyncFlyoutRouteParams'
import { ExternalPlatformType } from '../../ProductListingV2/types'
import {
  startLoading,
  stopLoading,
  LoadingTypes,
  isLoading as Loading,
} from '@labrav/common'

const creationRoutes: SecondaryNavigationRoutesType[] = [
  {
    key: '1',
    paths: ['/product-details'],
    name: 'Product listing',
    disabled: false,
    icon: () => (
      <FontAwesomeIcon
        icon={faList}
        style={{ width: '20px', height: '16px' }}
      />
    ),
  },
  {
    key: '2',
    paths: ['/landing-page'],
    name: 'Buyer registration page',
    disabled: false,
    icon: () => (
      <FontAwesomeIcon
        icon={faInputText}
        style={{ width: '20px', height: '16px' }}
      />
    ),
  },
  {
    key: '3',
    paths: ['/notification-recipients'],
    name: 'Notifications',
    disabled: false,
    icon: () => (
      <FontAwesomeIcon
        icon={faBell}
        style={{ width: '20px', height: '16px' }}
      />
    ),
  },
]

const CompletedIcon = () => (
  <FontAwesomeIcon
    icon={faCircleCheck}
    data-testid="checkmark"
    style={{ height: '16px', width: '16px' }}
    color="green"
  />
)

export const AddEditProductListingMicrosoft = ({
  isImpartner = false,
  externalPlatformType,
}: {
  isImpartner?: boolean
  externalPlatformType?: ExternalPlatformType
}) => {
  // Sync route params to selectedAccountIds for FLYOUT
  useSyncFlyoutRouteParams()

  const { search: queryString } = useLocation()
  const listingType = new URLSearchParams(queryString).get('listingTypeInfo')
  const { classes } = useStyles()
  const { productId = '' } = useParams<{ productId?: string }>()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const accountId = useAccountId({ product: 'flyout', cloud: CloudType.AZURE })
  const hasFetchedRef = useRef(false)
  const { products: productRows } = useFlyOutProductsBasedOnSelectedCloud()

  const hideNotificationPage =
    externalPlatformType === ExternalPlatformType.IMPARTNER

  const hideLandingPage =
    externalPlatformType === ExternalPlatformType.IMPARTNER

  const hideMultipleSections = hideLandingPage && hideNotificationPage

  const [enableUpdateMigrateList, setEnableUpdateMigrateList] = useState(true)

  const { isLoading: productLoading } = useSelector<{
    isLoading: boolean
  }>(state => ({
    isLoading: Loading(state.loading)(LoadingTypes.FETCH_PRODUCTS),
  }))
  const { userProfile } = useSelector<UserProfileState>(
    state => state.userProfile
  )

  const isMigratitionInQueueProducts =
    productRows?.filter(
      item => item?.status === ProductStatus.PRODUCT_STATUS_MIGRATION_IN_QUEUE
    )?.length > 0

  const { microsoftProductForm: flyoutProductForm } =
    useSelector<PoductObjectInCreation>(
      state => state.flyoutProductInCreation.currentProductInCreation
    )

  const [activeLink, setActiveLink] = React.useState('/product-details')
  const [page, setPage] = useState<FlyoutProductAddEditSectionName>(
    FlyoutProductAddEditSectionName.GENERAL_INFORMATION
  )

  const isMigrated = listingType === FlyoutListingProductType.MIGRATED
  const navigateRoute = (path: string) => {
    setActiveLink(path)
  }
  const FlyoutOnboardingRoutes: {
    title: string
    routes: SecondaryNavigationRoutesType[]
  } = useMemo(
    () => ({
      title: 'Listing creation steps -',
      routes: creationRoutes.map(creationRoute => {
        const isProductSectionCompleted = getIsProductSectionCompletedMicrosoft(
          creationRoute?.paths ? creationRoute?.paths[0] : '',
          flyoutProductForm[FlyoutProductAddEditSectionName.PAGE_MARKER]
        )
        return {
          ...creationRoute,
          onClick: () =>
            setActiveLink(creationRoute?.paths ? creationRoute?.paths[0] : ''),
          ...(!isMigratitionInQueueProducts &&
          (creationRoute?.key === '2' || creationRoute?.key === '3')
            ? { disabled: true }
            : {}),
          ...(isProductSectionCompleted ? { endIcon: CompletedIcon } : {}),
        }
      }),
    }),
    [flyoutProductForm, isMigrated, isMigratitionInQueueProducts]
  )

  const selectedRoute = useMemo(
    () =>
      [...FlyoutOnboardingRoutes.routes].find(({ paths }) =>
        paths?.includes(activeLink)
      ),
    [FlyoutOnboardingRoutes.routes, activeLink]
  )

  useEffect(() => {
    if (accountId) {
      dispatch(getProducts(accountId, 'AZURE'))
    }
    return () => {
      if (accountId) {
        dispatch(getProducts(accountId, 'AZURE'))
      }
    }
  }, [accountId])

  useEffect(() => {
    if (!isEmpty(flyoutProductForm) && selectedRoute) {
      const currentPage = getPageProductCreation(
        selectedRoute?.paths ? selectedRoute?.paths[0] : '',
        isMigrated
      )
      currentPage && setPage(currentPage)
    }
  }, [selectedRoute, isMigrated])

  useEffect(() => {
    if (!productLoading) {
      if (listingType) {
        dispatch(
          getProductInCreationMicrosoft({
            listingType: listingType as FlyoutListingProductType,
          })
        )
      }
    }
  }, [productLoading])

  const completePercentage = useMemo(
    () =>
      getProductCompletePercentage(
        flyoutProductForm[FlyoutProductAddEditSectionName.PAGE_MARKER]
      ),
    [flyoutProductForm[FlyoutProductAddEditSectionName.PAGE_MARKER]]
  )

  useEffect(() => {
    const contentEle = document.getElementById('product-creation-top')
    if (contentEle) {
      contentEle.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }, [activeLink])

  const fetchMoreData = async () => {
    dispatch(startLoading(LoadingTypes.FLYOUT_PRODUCT_MIGRATION_PRODUCTS))
    try {
      if (accountId) {
        await dispatch(getFlyOutMigrationProductsData(accountId, 'AZURE'))
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      dispatch(stopLoading(LoadingTypes.FLYOUT_PRODUCT_MIGRATION_PRODUCTS))
    }
  }

  useEffect(() => {
    hasFetchedRef.current = false
  }, [accountId])

  useEffect(() => {
    if (!productLoading && !hasFetchedRef.current) {
      fetchMoreData()
      hasFetchedRef.current = true
    }
  }, [accountId, productLoading])

  if (isEmpty(flyoutProductForm)) {
    return <></>
  }

  return (
    <div data-testid={'add-edit-product-listing'} className={classes.root}>
      {!isImpartner && (
        <div className={classes.headerContainer}>
          <div className={classes.appTitleHeading}>
            <div
              className={classes.appBackIcon}
              data-testid="back-button"
              onClick={() => navigate(-1)}
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
                style={{
                  width: '24px',
                  height: '24px',
                  fontSize: '24px',
                  padding: '0px 12px 0px 0px',
                  color: '#1942C5',
                }}
              />
            </div>
            <Typography
              variant="h1"
              data-testid="heading"
              className={classes.appTitleHeadingText}
            >
              <ShortenedNameV2
                name={'Migrate product listing'}
              ></ShortenedNameV2>
            </Typography>
          </div>

          <SelectedCloudIcon />
        </div>
      )}

      <div className={classes.contentContainer}>
        {!hideMultipleSections && (
          <SidePanelV3
            activeLink={activeLink}
            onlyActions
            title="Listing creation steps -"
            showProgress
            progressCount={completePercentage}
            routes={FlyoutOnboardingRoutes.routes}
            openDrawer={true}
            navigateRoute={navigateRoute}
            footerSubMenuRoutes={[]}
            userInfo={{
              name: 'string',
              roles: [],
            }}
            customFooter={!isImpartner ? <TeamMembersV2 /> : <></>}
            isNew={false}
          />
        )}
        <div
          className={
            !hideMultipleSections
              ? classes.contentWrapper
              : classes.contentWrapperFullWidth
          }
        >
          <>
            {!isEmpty(flyoutProductForm) ? (
              <div className={classes.content}>
                <Formik
                  initialValues={flyoutProductForm}
                  validationSchema={FlyoutProductValidationSchemaMicrosoft}
                  validateOnMount={true}
                  onSubmit={() => {}}
                  enableReinitialize
                >
                  {formikProps => {
                    const handleSubmitProductForm = useCallback(
                      async (handleSubmit: () => void) => {
                        await formikProps.submitForm()
                        const isCurrentPageHaveErr =
                          await validateMicrosoftProductCreationFlow(
                            page,
                            formikProps
                          )
                        if (!isCurrentPageHaveErr) {
                          handleSubmit()
                        }
                      },
                      [formikProps, page]
                    )
                    return (
                      <Form>
                        <ScrollToFieldError />
                        <div
                          className={classes.contentBody}
                          id={'product-creation-top'}
                        >
                          <div className={clsx(classes.formContainer)}>
                            <div>
                              {page ===
                                FlyoutProductAddEditSectionName.MIGRATION_DETAILS && (
                                <FlyOutMigrationProductsList
                                  enableUpdateMigrateList={
                                    enableUpdateMigrateList
                                  }
                                  setEnableUpdateMigrateList={
                                    setEnableUpdateMigrateList
                                  }
                                  isImpartner={isImpartner}
                                />
                              )}
                              {page ===
                                FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS && (
                                <FlyoutLandingPageSection />
                              )}
                              {page ===
                                FlyoutProductAddEditSectionName.NOTIFICATIONS_RECIPIENTS && (
                                <FlyoutNotificationSectionMicrosoft />
                              )}
                            </div>
                          </div>
                        </div>
                        <AddEditProductListingFooter
                          activeLink={activeLink}
                          setActiveLink={setActiveLink}
                          page={page}
                          userProfileId={userProfile?.id as string}
                          productId={productId}
                          handleSubmitForm={handleSubmitProductForm}
                          enableUpdateMigrateList={enableUpdateMigrateList}
                          setEnableUpdateMigrateList={
                            setEnableUpdateMigrateList
                          }
                          isImpartner={isImpartner}
                          hideMultipleSections={hideMultipleSections}
                        />
                      </Form>
                    )
                  }}
                </Formik>
              </div>
            ) : (
              <></>
            )}
          </>
        </div>
        <SnackBar />
      </div>
    </div>
  )
}
